import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "dff__intro-dff" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/ResourcePackages/BaldwinHardware/assets/dist/images/logos/lock-designer-pp.svg",
    alt: "puzzle pieces",
    width: "40",
    height: "40"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Door Fit Finder")
], -1 /* HOISTED */)
const _hoisted_2 = { class: "dff__question-heading" }
const _hoisted_3 = {
  key: 0,
  class: "dff__answer-list"
}
const _hoisted_4 = { class: "dff__answer-item" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "dff__answer-card-image-wrap"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "dff__answer-card-title" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Back")

import {ref, onMounted, onBeforeUnmount} from 'vue';
import { useStore } from 'vuex';
import jsonData from 'Data/doorfitfinder.json';

export default {
  props: ['questionobject', 'question', 'answers', 'questionref'],
  setup(__props) {

const { questionobject, question, answers, questionref } = __props

const store = useStore();

const isFirstQuestion = ref(false);



const setAnswer = (answer) => {
	store.commit('setAnsweredQuestionData', answer?.answerValue);
	store.commit('updatePreviousQuestion', question?.id);
	store.commit('updateActiveQuestion', answer?.nextQuestion);

	if(answer.nextQuestion === 'loading') {
		store.commit('updateActiveComponent', answer?.nextQuestion);
	}
};

const checkIfIsFirstQuestion = async(id) => {
	// Find the item with the specified ID
	const questionItem = await jsonData.questions?.find(item => item?.id === questionobject?.id);

	// Check if the item is at index 0
	isFirstQuestion.value = questionItem?.id === `Q1`;
}

onMounted(() => {
	checkIfIsFirstQuestion(question?.id);
	if (questionref.value) {
		setTimeout(() => {
			questionref.value.classList.add('state-mounted')
		}, 500);
	}
});

onBeforeUnmount(() => {
	if (questionref.value) {
		questionref.value.classList.remove('state-mounted');
		setTimeout(() => {
			//giving the css animation time to finish before mounting the next thing
		}, 500);
	}
});

const goBack = () => {
	store.commit('updateActiveQuestion', 'Q1');
	store.commit('removeSetDFFStates');
};

return (_ctx, _cache) => {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", {
    class: "dff__question",
    ref: __props.questionref
  }, [
    _hoisted_1,
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.question), 1 /* TEXT */),
    (__props.answers?.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.answers, (answer) => {
            return (_openBlock(), _createElementBlock("li", _hoisted_4, [
              _createElementVNode("div", {
                class: "dff__answer-card",
                onClick: $event => (setAnswer(answer))
              }, [
                (answer?.answerImage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("img", {
                        class: "dff__answer-card-image",
                        src: answer?.answerImage,
                        alt: answer?.answer
                      }, null, 8 /* PROPS */, _hoisted_7)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_8, _toDisplayString(answer?.answer), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_5)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    (isFirstQuestion.value === false)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          onClick: _cache[0] || (_cache[0] = $event => (goBack())),
          class: "dff__back btn btn-outline-primary btn-lg"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}
}

}